var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      staticClass: "layout__header d-md-none primary-text position-relative",
      staticStyle: { "z-index": "1" }
    },
    [
      _c("logo"),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "mobile-nav" } },
        [
          _c(
            "button",
            {
              staticClass: "btn__icon primary-text",
              attrs: { "aria-haspopup": "dialog", "aria-label": _vm.navLabel },
              on: {
                click: function($event) {
                  _vm.open = true
                }
              }
            },
            [
              _c("span", {
                staticClass: "icon-menu icon__x2",
                attrs: { "aria-hidden": "true" }
              })
            ]
          ),
          _vm._v(" "),
          _c("app-nav", {
            attrs: {
              nav: _vm.nav,
              current: _vm.current,
              open: _vm.open,
              search: _vm.search,
              "display-back": true
            },
            on: {
              close: function($event) {
                return _vm.onClose()
              },
              next: function($event) {
                return _vm.onNext($event)
              },
              "open-search": function($event) {
                _vm.search = true
              },
              "close-search": function($event) {
                return _vm.onClose()
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn__icon btn__icon--small primary-text",
          attrs: { "aria-haspopup": "dialog", "aria-label": _vm.searchLabel },
          on: {
            click: function($event) {
              return _vm.onSearchClick()
            }
          }
        },
        [
          _c("span", {
            staticClass: "icon-search",
            attrs: { "aria-hidden": "true" }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }